<template>
  <b-card
    class="earnings-card"
  >
    <b-card-header>
      <b-card-title>{{ $t('Deposit By Customer Type') }}</b-card-title>
      <feather-icon
        icon="RotateCwIcon"
        class="cursor-pointer"
        @click="fetchAccountTypeByDeposit"
      />
    </b-card-header>
    <b-row>
      <b-col md="12">
        <b-row
          v-for="(accountType, accountTypeIndex) in accountTypes"
          :key="accountTypeIndex"
          class="d-flex justify-content-between flex-wrap"
        >
          <b-col md="4">
            <p :class="accountTypeIndex === 0 ? 'font-weight-bolder' : ''">
              {{ $t(accountType.accountType) }}
            </p>
          </b-col>
          <b-col md="3">
            <p :class="accountTypeIndex === 0 ? 'font-weight-bolder' : ''">
              {{ $t(accountType.count) }}
            </p>
          </b-col>

          <b-col md="5">
            <p :class="accountTypeIndex === 0 ? 'font-weight-bolder' : ''">
              {{ $t(accountType.amount) }}
            </p>
          </b-col>

        </b-row>
      </b-col>

      <!-- chart -->
      <!-- <b-col cols="5">
        <vue-apex-charts
          height="120"
          :options="earningsChart.chartOptions"
          :series="series"
        />
      </b-col> -->
    </b-row>
    <Spinner :show="isLoadingDepositByAccountType" />
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BCardTitle, BCardHeader,
} from 'bootstrap-vue'
// import VueApexCharts from 'vue-apexcharts'
import { onMounted, ref } from '@vue/composition-api'
import { useActions } from 'vuex-composition-helpers'
import Spinner from '@/views/components/spinner/Spinner.vue'
import useToastAlert from '../../../composable/useToast'
import { toBalance } from '@/helpers/formatAmount'
import toNumber from '@/helpers/toNumber'

const $earningsStrokeColor2 = '#FFD700'
const $earningsStrokeColor3 = '#2E93fA'
const $earningsStrokeColor4 = '#7367f0'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BCardTitle,
    BCardHeader,
    // VueApexCharts,
    Spinner,
  },
  setup() {
    const {
      getAccountTypeByDeposit,
    } = useActions({
      getAccountTypeByDeposit: 'dashboard/getAccountTypeByDeposit',
    })
    const { toastAlert } = useToastAlert()
    const isLoadingDepositByAccountType = ref(false)
    const accountTypes = ref([])
    const series = ref([])

    const earningsChart = ref({
      chartOptions: {
        chart: {
          type: 'donut',
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: { show: false },
        comparedResult: [2, -3, 8],
        labels: ['Corporate', 'Group', 'Individual'],
        stroke: { width: 0 },
        colors: [$earningsStrokeColor2, $earningsStrokeColor3, $earningsStrokeColor4],
        grid: {
          padding: {
            right: -20,
            bottom: -8,
            left: -20,
          },
        },
        plotOptions: {
          pie: {
            startAngle: -10,
            donut: {
              labels: {
                show: true,
                name: {
                  offsetY: 15,
                },
                value: {
                  offsetY: -15,
                  formatter(val) {
                    // eslint-disable-next-line radix
                    return `${parseInt(val)}%`
                  },
                },
                total: {
                  show: true,
                  offsetY: 15,
                  label: 'Individual',
                  // formatter() {
                  //   return `${series.value[2]}%`
                  // },
                },
              },
            },
          },
        },
        responsive: [
          {
            breakpoint: 1325,
            options: {
              chart: {
                height: 100,
              },
            },
          },
          {
            breakpoint: 1200,
            options: {
              chart: {
                height: 120,
              },
            },
          },
          {
            breakpoint: 1045,
            options: {
              chart: {
                height: 100,
              },
            },
          },
          {
            breakpoint: 992,
            options: {
              chart: {
                height: 120,
              },
            },
          },
        ],
      },
    })

    const fetchAccountTypeByDeposit = async () => {
      try {
        isLoadingDepositByAccountType.value = true
        const response = await getAccountTypeByDeposit()
        const { status, data } = response
        if (status === 200 && data) {
          series.value = data.map(item => item.percentage)
          accountTypes.value = data.map(item => ({
            ...item,
            accountType: item.customerType,
            amount: toBalance(item.amount),
            count: toNumber(item.count),
          }))
          accountTypes.value.unshift({
            accountType: 'Customer Types',
            count: 'Count',
            amount: 'Amount',
          })

          isLoadingDepositByAccountType.value = false
        }
      } catch (err) {
        toastAlert(err)
      } finally {
        isLoadingDepositByAccountType.value = false
      }
    }

    onMounted(async () => {
      await fetchAccountTypeByDeposit()
      // await getBranches()
    })

    return {
      accountTypes,
      series,
      isLoadingDepositByAccountType,
      earningsChart,
      fetchAccountTypeByDeposit,
    }
  },
}
</script>

<style scoped>
.card .card-header {
    padding: 1.5rem 0;
}
</style>
